






























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "../../lib/ajax";
import EditLanguage from "./edit-language.vue"
@Component({
    components: {EditLanguage}
})
export default class Languages extends AbpBase {
    loading: boolean = false;
    list: Array<any> = new Array<any>();

    editId: number = null;
    editModalShow: boolean = false;

    languagesOutput = {
        items: [],
        defaultLanguageName: ""
    };
    async getLanguages() {
        this.loading = true;
        let reponse = await Ajax.get("/api/services/app/Language/GetLanguages");
        this.languagesOutput = reponse.data.result;
        this.loading = false;
    }
    created() {
        this.getLanguages();
    }
    edit(id) {
        this.editId = id;
        this.editModalShow = true;
    }
    columns = [
        {
            title: this.L("DisplayName"),
            slot: "displayName"
        },
        {
            title: this.L("LanguageCode"),
            key: "name"
        },
        {
            title: this.L("Actived"),
            key: "isDisabled",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    !params.row.isDisabled ? this.L("Yes") : this.L("No")
                );
            }
        },
        {
            title: this.L("CreationTime"),
            key: "creationTime",
            width: 120,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    new Date(params.row.creationTime).toLocaleDateString()
                );
            }
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 80,
            align: "center",
            render: (h: any, params: any) => {
                return h(
                    "Dropdown",
                    {
                        style: {
                            marginLeft: "5px"
                        },
                        props: {
                            placement: "bottom-start",
                            transfer: true
                        },
                        on: {
                            "on-click": async name => {
                                switch (name) {
                                    case "edit":
                                        this.edit(params.row.id);
                                        break;
                                    case "delete":
                                        this.$Modal.confirm({
                                            title: this.L("Tips"),
                                            content: this.L(
                                                "LanguageDeleteWarningMessage"
                                            ),
                                            okText: this.L("Yes"),
                                            cancelText: this.L("No"),
                                            onOk: async () => {
                                                await Ajax.delete('/api/services/app/Language/DeleteLanguage?Id='+params.row.id);
                                                await this.getLanguages();
                                            }
                                        });
                                        break;
                                    case "setDefaultLanguage":
                                        await Ajax.post('/api/services/app/Language/SetDefaultLanguage',{name: params.row.name});
                                        await this.getLanguages();
                                        break;
                                    case "updateTextInfo":
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    },
                    [
                        h(
                            "a",
                            {
                                attrs: {
                                    href: "javascript:void(0)"
                                }
                            },
                            [
                                this.L("Actions"),
                                h("Icon", {
                                    props: {
                                        type: "ios-arrow-down"
                                    }
                                })
                            ]
                        ),
                        h(
                            "DropdownMenu",
                            {
                                slot: "list"
                            },
                            [
                                h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: "edit"
                                        }
                                    },
                                    this.L("Edit")
                                ),
                                h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: "delete"
                                        }
                                    },
                                    this.L("Delete")
                                ),
                                h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: "setDefaultLanguage"
                                        }
                                    },
                                    this.L("SetDefaultLanguage")
                                ),
                                h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: "updateTextInfo"
                                        }
                                    },
                                    this.L("UpdateTextInfo")
                                ),
                            ]
                        )
                    ]
                );
            }
        }
    ];
}
